<template><section><h1>ExtendedTextarea 多功能文本输入框</h1>
<h2>基本用法</h2>
<p>:::demo</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"pug"</span>&gt;</span>
sem-cell-group
  sem-cell(title="请假原因")
  sem-cell
    sem-extended-textarea(
      :text.sync="text",
      :files.sync="files",
    )
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">text</span>: <span class="hljs-string">''</span>,
        <span class="hljs-attr">files</span>: [],
      }
    },
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<p>:::</p>
<h2>Props</h2>
<table>
<thead>
<tr>
<th>属性</th>
<th>必填</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td>true</td>
<td>文本</td>
<td>String</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>files</td>
<td>-</td>
<td>文件</td>
<td>File[]</td>
<td>-</td>
<td>[]</td>
</tr>
<tr>
<td>disableFile</td>
<td>-</td>
<td>不使用文件上传</td>
<td>boolean</td>
<td>-</td>
<td>false</td>
</tr>
<tr>
<td>maxFiles</td>
<td>-</td>
<td>最大文件上传数量</td>
<td>number</td>
<td>-</td>
<td>5</td>
</tr>
<tr>
<td>placeholder</td>
<td>-</td>
<td>文本框的占位符</td>
<td>string</td>
<td>-</td>
<td>'请填写'</td>
</tr>
<tr>
<td>textareaStyle</td>
<td>-</td>
<td>文本框样式</td>
<td>-</td>
<td>-</td>
<td></td>
</tr>
</tbody>
</table>
<h2>Events</h2>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>update:text</td>
<td>文本更新</td>
<td>text</td>
</tr>
<tr>
<td>update:images</td>
<td>图片更新</td>
<td>File[]</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  export default {
    data() {
      return {
        text: '',
        files: [],
      }
    },
  }
</script>